import React, { useContext, useEffect } from 'react'

//Internal Imports
import MobileHeader from './mobileHeader'
import TabletHeader from './tabletHeader'
import DesktopHeader from './desktopHeader'
import { ScreenContext } from 'context/ScreenContext'

const Header = () => {
    const { mobile, tablet, desktop, updateMedia } = useContext(ScreenContext)
    useEffect(() => {
        window.addEventListener('resize', updateMedia)
        return () => window.removeEventListener('resize', updateMedia)
    }, [])

    switch (true) {
        case mobile: {
            return <MobileHeader />
        }
        case tablet: {
            return <DesktopHeader />
        }
        case desktop: {
            return <DesktopHeader />
        }
        default:
            return <DesktopHeader />
    }
}

export default Header
